export class LoadableObject {
    display: string;
    id: string;
}
